import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuDatePicker from '../components/MenuDatePicker';
import ListDatePicker from '../components/ListDatePicker';
import ListTimePicker from '../components/ListTimePicker';
import { getEventTimeFormatted, getFormattedEventDates, hasActiveInventoryFilter } from '../selectors/eventSeries';
import { getEventTimesForDates, setSelectedChildEvent, clearEventTimes, selectChildEventAndContinue, setChildEventAdditionalInfo, setSelectedDate, changeDateInternal, calendarView } from '../actions/event-series';
import { getSeriesConfig } from 'checkout/selectors/ui';
import { createLoadingSelector } from 'checkout/selectors/helpers';
import { getMainEvent } from '../../../selectors/event';
import { clearSelectedPriceLevels } from '../../ticket-picker/actions/ticket-picker';
import { clearSelectedBundles } from '../../bundle-picker/actions/bundle-picker';
import { clearSelectedProducts } from '../../product-picker/actions/product-picker';

class MenuDatePickerContainer extends Component {

    fetchedEventTimes = false;

    componentDidMount() {
        this.fetchEventTimes();
    }

    fetchEventTimes = () => {
        let time = null;
        if (this.props.selectedDay) {
            time = this.props.selectedDay.toISOString();
        }
        if (
            !this.fetchedEventTimes &&
            (Object.keys(this.props.eventTimes).length === 0 ||
            (time && !this.props.eventTimes[time])) &&
            !this.props.skipTimeLoad
        ) {
            this.fetchedEventTimes = true;
            let events = this.props.eventDates;
            if(this.props.selectedDay) {
                events = [this.props.selectedDay];
            }

            this.props.getEventTimesForDates(events);
        }
    }

    render() {
        if(this.props.type === "menu" || this.props.type === "calendar-menu") {
            return (
                <MenuDatePicker
                    eventTimes={this.props.eventTimes}
                    loading={this.props.loading}
                    onEventSelected={this.onEventSelected}
                    onContinue={this.onContinue}
                    selectedChildEvent={this.props.selectedChildEvent}
                    showSoldOut={this.props.showSoldOut}
                    locale={this.props.locale}
                    selectedDay={this.props.selectedDay}
                />
            );
        } else if(this.props.type === "calendar-list") {
            return <ListTimePicker
                eventTimes={this.props.eventTimes}
                loading={this.props.loading}
                onEventSelected={this.onEventSelected}
                onContinue={this.onContinue}
                selectedChildEvent={this.props.selectedChildEvent}
                showSoldOut={this.props.showSoldOut}
                locale={this.props.locale}
                selectedDay={this.props.selectedDay}
                hasActiveInventoryFilter={this.props.hasActiveInventoryFilter}
                inventoryFilterResults={this.props.inventoryFilterResults}
            />
        } else if(this.props.type === "list") {
            return <ListDatePicker
                eventTimes={this.props.eventTimes}
                loading={this.props.loading}
                onEventSelected={this.onEventSelected}
                onContinue={this.onContinue}
                selectedChildEvent={this.props.selectedChildEvent}
                showSoldOut={this.props.showSoldOut}
                locale={this.props.locale}
                collapsed={this.props.collapsed}
                isDateChanging={this.props.isDateChanging}
                selectedDayDate={this.props.selectedDayDate}
                setSelectedDate={this.props.setSelectedDate}
                setIsDateChanging={this.props.setIsDateChanging}
                getEventTimeFormatted={this.props.getEventTimeFormatted}
                changeDateInternal={this.props.changeDateInternal}
                calendarView={this.props.calendarView}
            />
        }
    }

    onEventSelected = (id, additionalInfo) => {
        this.props.setSelectedChildEvent(Number(id));
        this.props.setChildEventAdditionalInfo(additionalInfo);
        this.props.selectChildEventAndContinue(Number(id), false);
        this.props.clearSelectedPriceLevels();
        this.props.clearSelectedBundles();
        this.props.clearSelectedProducts();
        this.props.setIsDateChanging?.(false);
    }
}

const eventTimesLoading = createLoadingSelector("EVENT_TIMES");
const mapStateToProps = (state, props) => {
    let showSoldOut = getSeriesConfig(state).showSoldOut;
    let times = state.eventSeries.eventTimesByDate;

    if(props.selectedDay) {
        const selectedDay = new Date(props.selectedDay.toDateString());
        let time = selectedDay.toISOString();
        if(times[time]) {
            let tempTimes = {};
            tempTimes[time] = times[time];
            times = tempTimes;
        }
    }

    if(showSoldOut === false) {
        for (const date in times) {
            times[date] = times[date].filter((item) => {
                return item.eventStatus === "sold_out" ? false : true;
            });

            if(times[date].length === 0) {
                delete times[date];
            }
        }
    }

    return {
        eventDates: getFormattedEventDates(state),
        parentId: getMainEvent(state)?.event?.event_id,
        apiUrl: state.ui.apiUrl,
        eventTimes: times,
        selectedChildEvent: state.eventSeries.selectedChildEvent,
        selectedDayDate: state.eventSeries.selectedDateObject,
        type: getSeriesConfig(state).calendarType,
        showSoldOut: showSoldOut,
        locale: state.intl.locale,
        loading: eventTimesLoading(state),
        hasActiveInventoryFilter: hasActiveInventoryFilter(state),
        inventoryFilterResults: state.inventoryFilter.filterResults,
        seriesChildAdditionalInfo: state.eventSeries.seriesChildAdditionalInfo,
        getEventTimeFormatted: getEventTimeFormatted(state),
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getEventTimesForDates,
        setSelectedChildEvent,
        clearEventTimes,
        selectChildEventAndContinue,
        setChildEventAdditionalInfo,
        clearSelectedPriceLevels,
        clearSelectedBundles,
        clearSelectedProducts,
        setSelectedDate,
        changeDateInternal,
        calendarView,
    }, dispatch);
};

MenuDatePickerContainer.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuDatePickerContainer)
